import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import Meta from '../../components/layout/Meta';
import config from '../../config';

const ContactScreen = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const brandColor = '#b5430f';

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Aquí iría la lógica de envío (RTK Query o similar)
        console.log('Formulario enviado:', formData);
        alert('Gracias por contactarnos. Te responderemos pronto.');
        setFormData({ name: '', email: '', subject: '', message: '' });
    };

    return (
        <>
            <Meta title={`Contáctanos - ${config.company.name}`} />
            <Container className="py-5">
                <h1 className="text-center mb-5" style={{ color: brandColor, fontWeight: 'bold' }}>Contáctanos</h1>
                
                <Row className="g-5">
                    {/* Información de Contacto */}
                    <Col lg={5}>
                        <Card className="h-100 border-0 shadow-sm" style={{ backgroundColor: '#fff5f0' }}>
                            <Card.Body className="p-4">
                                <h3 className="mb-4" style={{ color: brandColor }}>Información</h3>
                                <p className="text-muted mb-4">
                                    Estamos aquí para ayudarte. Si tienes preguntas sobre nuestros productos, envíos o alianzas, no dudes en escribirnos.
                                </p>
                                
                                <div className="d-flex align-items-start mb-4">
                                    <div className="me-3 mt-1">
                                        <FaMapMarkerAlt size={24} style={{ color: brandColor }} />
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-1">Ubicación</h5>
                                        <p className="text-muted mb-0">{config.company.address}</p>
                                    </div>
                                </div>

                                <div className="d-flex align-items-start mb-4">
                                    <div className="me-3 mt-1">
                                        <FaPhone size={24} style={{ color: brandColor }} />
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-1">Teléfono</h5>
                                        <p className="text-muted mb-0">{config.company.phone}</p>
                                    </div>
                                </div>

                                <div className="d-flex align-items-start">
                                    <div className="me-3 mt-1">
                                        <FaEnvelope size={24} style={{ color: brandColor }} />
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-1">Email</h5>
                                        <p className="text-muted mb-0">{config.company.email}</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Formulario de Contacto */}
                    <Col lg={7}>
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="p-4">
                                <h3 className="mb-4" style={{ color: brandColor }}>Envíanos un mensaje</h3>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6} className="mb-3">
                                            <Form.Group controlId="name">
                                                <Form.Label column='lg'>Nombre Completo</Form.Label>
                                                <Form.Control
                                                    type="text" 
                                                    placeholder="Tu nombre" 
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <Form.Group controlId="email">
                                                <Form.Label column='lg'>Correo Electrónico</Form.Label>
                                                <Form.Control
                                                    type="email" 
                                                    placeholder="tucorreo@ejemplo.com" 
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group className="mb-3" controlId="subject">
                                        <Form.Label column='lg'>Asunto</Form.Label>
                                        <Form.Control
                                            type="text" 
                                            placeholder="Motivo de tu mensaje" 
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required 
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4" controlId="message">
                                        <Form.Label column='lg'>Mensaje</Form.Label>
                                        <Form.Control
                                            as="textarea" 
                                            rows={5} 
                                            placeholder="Escribe tu mensaje aquí..." 
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required 
                                        />
                                    </Form.Group>

                                    <Button 
                                        type="submit" 
                                        className="w-100 py-2 border-0"
                                        style={{ backgroundColor: brandColor }}
                                    >
                                        Enviar Mensaje
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ContactScreen;
